function ProjectTempalteList(props) {

    return (<>Coming Soon Project Templates</>)
}

export default ProjectTempalteList;